import { FC, ReactNode } from 'react';

import classNames from 'classnames';
import EmptyModal, { EmptyModalProps } from './EmptyModal.tsx';
import MainText from '../../typography/MainText.tsx';
import IconButton from '../../buttons/IconButton.tsx';

import { IconKeys } from '../../constants/icons.ts';
import Flex from '../../layout/Flex.tsx';
import H3 from '../../typography/H3.tsx';

export type BaseModalProps = EmptyModalProps & {
  title: ReactNode;
  description?: string;

  titleClass?: string;
  descriptionClass?: string;

  beforeChildren?: ReactNode;
};

const BaseModal: FC<BaseModalProps> = ({
  title,
  description,
  titleClass,
  children,
  descriptionClass,
  beforeChildren,
  ...props
}) => (
  <EmptyModal {...props}>
    {beforeChildren}

    <Flex.Wrapper gap="24px" jBetween iCenter>
      <H3 className={titleClass}>{title}</H3>

      <IconButton
        className="!rounded-sm !p-[6px] after:!p-[16px]"
        iconClass="!w-[20px] !h-[20px]"
        icon={IconKeys.Close}
        onClick={props.onClose}
      />
    </Flex.Wrapper>

    {description && (
      <MainText className={classNames('mt-[24px]', descriptionClass)}>{description}</MainText>
    )}

    {children}
  </EmptyModal>
);

export default BaseModal;
